if(document.querySelector('recharge-subscription-widget')){
  rechargeWidget = document.querySelector('recharge-subscription-widget').shadowRoot
  // MutationOvservers for custom Recharge Widget
  const rechargeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('div.rc-widget__root') || node.querySelector?.('div.rc-widget__root'))) {
          console.log('Recharge loaded')
          initRecharge()
        }
      }

      // Trigger on subscription-selection changes within ReCharge (between one-time & subscription options)
      if(mutation.type === 'attributes' && mutation.attributeName === 'rc-selected' && !mutation.target.hasAttribute('rc-not-selected')){
        let planSelected = mutation.target.classList.contains('rc-selection__onetime') ? 'oneTime' : 'subscription'
        document.body?.setAttribute('purchase-option', planSelected)
        updateRechargePrices(planSelected)
        updateATCButton()

        const purchaseOptionChanged = new CustomEvent('purchaseOptionChanged', {
          detail: {
            plan_selected: planSelected,
          }
        });
      
        window.dispatchEvent(purchaseOptionChanged);

      }

      //Watch for price updates within widget (variant changes) & update required UI elements
      if (mutation.type === 'characterData') {
        updateATCButton()      
        updateWidgetCompareAtPrices()
        let params = new URLSearchParams(document.location.search);
        let selectedVariant = parseInt(params.get("variant") || productVariants[0].id)
        renderSavingsBadge(parseInt(selectedVariant))
      }

    })
  });
  rechargeObserver.observe(document.querySelector('recharge-subscription-widget')?.shadowRoot, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
  });
}

//Function to initilise recharge widget customisations onsite
function initRecharge(){
  window.rechargeInit = true
  //Find currently selected ID & render savings badges
  let params = new URLSearchParams(document.location.search);
  let selectedVariant = parseInt(params.get("variant") || productVariants[0].id)
  renderSavingsBadge(parseInt(selectedVariant))

  document.body?.setAttribute('purchase-option', 'subscription')

  //Run script to handle subscription toggling
  appendWidgetCompareAtPrices()
  updateATCButton()
}

//Function to toggle price per wash based on subscription selection
function updateRechargePrices(planSelected){
  let oneTimePrices = document.querySelectorAll('.onetime_per_price')
  let subscriptionPrices = document.querySelectorAll('.subscription_per_price')

  if(planSelected === 'oneTime'){
    oneTimePrices.forEach((ele) => {
      ele.style.display = 'block'
    })

    subscriptionPrices.forEach((price) => {
      price.style.display = 'none'
    })
  }
  
  if(planSelected === 'subscription'){
    oneTimePrices.forEach((ele) => {
      ele.style.display = 'none'
    })
        
    subscriptionPrices.forEach((price) => {
      price.style.display = 'block'
    })
  }
}

// Accepts a variantId & renders the extra badge after checking if a message exists inside the productVariants object
function renderSavingsBadge(variantid){
  //Lookup savngs text
  let widget = document.querySelector('.recharge-subscription-widget');
  let savingsText = productVariants.find(variant => variant.id === variantid)?.save
  let onetimeSavingsText = productVariants.find(variant => variant.id === variantid)?.onetime_save

  document.documentElement.style.setProperty('--subscription-variant-savings-badge-text', savingsText ? `'${savingsText}'` : '');
  document.documentElement.style.setProperty('--onetime-variant-savings-badge-text', onetimeSavingsText ? `'${onetimeSavingsText}'` : '');

  if (savingsText || onetimeSavingsText) {
    widget.classList.add('badge-active');
  } else {
    widget.classList.remove('badge-active');
  }

}

// Generate + append compare at prices form Shopify to Recharge
function appendWidgetCompareAtPrices(){
    let customRechargeComparePrice = document.createElement('span')
    customRechargeComparePrice.classList = "shopifyComparePrice strike-through text-muted"

    rechargeWidget.querySelectorAll('.rc-purchase-option__prices').forEach((e) => {
        e.prepend(customRechargeComparePrice.cloneNode(true))
    })

    updateWidgetCompareAtPrices()
}

// Set the content of the compare at prices (Triggered when variants are changed)
function updateWidgetCompareAtPrices(){
  if(document.querySelector('[data-size="true"]') != undefined) {
      //If data-size exists check these elements for compare_at prices
      price = document.querySelector('[data-size="true"] .swatchInput:checked + .swatchLbl')?.getAttribute('data-comparepricewithcurrency')
      comparePrice = document.querySelector('[data-size="true"] .swatchInput:checked + .swatchLbl')?.getAttribute('data-compareprice')
      onetimePrice = document.querySelector('[data-size="true"] .swatchInput:checked + .swatchLbl')?.getAttribute('data-onetimeprice')
      subPrice = document.querySelector('[data-size="true"] .swatchInput:checked + .swatchLbl')?.getAttribute('data-subprice')
    } else if(document.querySelector('.swatchInput') != undefined) {
      // Support bundles etc, check first swatch input for compare_at prices
      price = document.querySelector('.swatchInput:checked + .swatchLbl')?.getAttribute('data-comparepricewithcurrency')
      comparePrice = document.querySelector('.swatchInput:checked + .swatchLbl')?.getAttribute('data-compareprice')
      onetimePrice = document.querySelector('.swatchInput:checked + .swatchLbl')?.getAttribute('data-onetimeprice')
      subPrice = document.querySelector('.swatchInput:checked + .swatchLbl')?.getAttribute('data-subprice')
    } else if (productVariants.length === 1 && document.querySelector('.pr_variants option') != undefined) {
      // Check items with no options
      price = document.querySelector('[data-section-type="product"] .pr_variants option')?.getAttribute('data-comparepricewithcurrency')
      comparePrice = document.querySelector('[data-section-type="product"] .pr_variants option')?.getAttribute('data-compareprice')
      onetimePrice = document.querySelector('[data-section-type="product"] .pr_variants option')?.getAttribute('data-onetimeprice')
      subPrice = document.querySelector('[data-section-type="product"] .pr_variants option')?.getAttribute('data-subprice')
    }
    
    // Reveal one-time prices if they are greater than product price
    if(parseInt(comparePrice) > parseInt(onetimePrice)){
      rechargeWidget.querySelectorAll('.rc-selection__onetime .shopifyComparePrice').forEach((compareAtPrice) => {
        compareAtPrice.innerHTML = `${price}`
      })
    } else {
      rechargeWidget.querySelectorAll('.rc-selection__onetime .shopifyComparePrice').forEach((compareAtPrice) => {
        compareAtPrice.innerHTML = ``
      })
    }

    // Reveal sub compare at prices if they are greater than product price
    if(parseInt(comparePrice) > parseInt(subPrice)){
      rechargeWidget.querySelectorAll('.rc-purchase-option__subscription .shopifyComparePrice').forEach((compareAtPrice) => {
        compareAtPrice.innerHTML = `${price}`
      })
    } else {
      rechargeWidget.querySelectorAll('.rc-purchase-option__subscription .shopifyComparePrice').forEach((compareAtPrice) => {
        compareAtPrice.innerHTML = ``
      })
    }
}

// Other custom javascript

//Animate PDP labels
// function updateLabelsInPDP() {
//   setTimeout(function () {
//     var total_colors = jQuery(
//       ".product-form__input.swatch:first-child .swatchLbl"
//     ).length;
//     var total_variants = productVariants.length;
//     var total_options = jQuery(".product-form__input.swatch .swatchLbl").length;
//     var selected_variant_id = parseInt(
//       jQuery('.pr_variants[name="id"]').val(),
//       10
//     );
//     var selected_variant = productVariants.find(
//       (variant) => variant.id === selected_variant_id
//     );
//     var selected_index = productVariants.findIndex(
//       (variant) => variant.id === selected_variant_id
//     );
//     var variants_per_color = total_variants / total_colors;
//     var color_group_index = Math.floor(selected_index / variants_per_color);
//     var size_options = jQuery(
//       ".product-form__input.swatch:nth-child(2) .swatchLbl"
//     );

//     size_options.each(function (index) {
//       var variant_index = color_group_index * variants_per_color + index;
//       var variant_obj = productVariants[variant_index];

//       if (variant_obj && variant_obj.save) {
//         jQuery(this).find(".save").fadeIn();
//         jQuery(this).find(".save").text(variant_obj.save);
//       } else {
//         jQuery(this).find(".save").fadeOut();
//       }
//     });
//   }, 50);
// }
//Animate PDP labels end

//Update ATC button text
function updateATCButton(){
  if(document.querySelectorAll('.price_d') != undefined){
    document.querySelectorAll('.price_d').forEach(price => {
      price.textContent = rechargeWidget.querySelector('[rc-selected]').querySelector('span.rc-price').textContent.match(/[€$£¥₹]\s?\d{1,3}(?:[.,]\d{2})?\s?(?:[A-Z]{3})?/)[0].replace(/[a-zA-Z]/g, '')
    })
  }
}

// Wesbite Announcement bar start
$(document).ready(function () {
  $(".announcement-inner svg").on("click", function () {
    $(".custom-announcement").addClass("announcemnet-hide");
  });
  // updateLabelsInPDP();
  jQuery(document).on(
    "click",
    ".product-form__input.swatch:first-child .swatchLbl",
    function () {
      // updateLabelsInPDP();
    }
  );
});
// Wesbite Announcement bar end

//Dynamically show/hide shipping messages start
const xhttp = new XMLHttpRequest();

xhttp.onload = function () {
  try {
    const country = JSON.parse(this.responseText).country;
    showShippingText(country);
  } catch (error) {
    console.error("Error parsing response:", error);
  }
};

xhttp.onerror = function () {
  console.error("Error fetching data from the API");
};

xhttp.open("GET", "https://ipapi.co/json/");
xhttp.send();

function showShippingText(country) {
  $(".shippingtext-AU, .shippingtext-US, .shippingtext-NZ").hide();

  if (country === "AU") {
    $(".shippingtext-AU").show();
  } else if (country === "US") {
    $(".shippingtext-US").show();
  } else if (country === "NZ") {
    $(".shippingtext-NZ").show();
  }
  // If the country doesn't match any of the specified values, nothing will be shown.
}
//Dynamically show/hide shipping messages end

//Dynamically update ATC Button text if product isn't offered as a subscription
window.addEventListener('variantChanged', (event) => {
  // if(document.getAttribute('data-template') == "product"){
    if(window?.rechargeInit != true){
      let variantLookupId = event.detail.variantId
      let price = productVariants.find(variant => variant.id === variantLookupId)?.price.replace(/[a-zA-Z]/g, '')
      
      document.querySelectorAll('.price_d').forEach(priceBtn => { priceBtn.textContent = price})
      let comparePrice = productVariants?.find(variant => variant.id === variantLookupId)?.compare_price?.replace(/[a-zA-Z]/g, '')
       if(comparePrice != undefined){
        document.querySelector('.price_d_compare').textContent = comparePrice
        document.querySelector('.rrp_price').style.display = 'inline-block'
      } else {
        document.querySelector('.rrp_price').style.display = 'none'
      }
    }
  // }
})

document.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(() => {
    if(window?.rechargeInit != true){
      let params = new URLSearchParams(document.location.search);
      let variantLookupId = parseInt(params.get("variant")) || productVariants[0].id
      let price = productVariants?.find(variant => variant.id === variantLookupId)?.price.replace(/[a-zA-Z]/g, '')
      document.querySelectorAll('.price_d').forEach(priceBtn => { priceBtn.textContent = price})
      
      let comparePrice = productVariants?.find(variant => variant.id === variantLookupId)?.compare_price?.replace(/[a-zA-Z]/g, '')
      if(comparePrice != undefined){
        document.querySelector('.price_d_compare').textContent = comparePrice
        document.querySelector('.rrp_price').style.display = 'inline-block'
      } else {
        document.querySelector('.rrp_price').style.display = 'none'
      }

      // let variantSoldOut = productVariants?.find(variant => variant.id === variantLookupId)?.force_sold_out == true;
    }
  }, 2000);
})

//New Desktop header mega menu
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header-link.has-children').forEach((ele) => {
      ele.addEventListener('mouseover', () => {
          ele.classList.add('menu-open');
      });
  });

  document.querySelector('.website-header').addEventListener('mouseleave', () => {
    document.querySelector('.header-link.has-children.menu-open')?.classList.remove('menu-open');
  });
});


//Set global header height css var
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');

  function updateHeaderHeightVar() {
    if (header) {
      const height = `${header.offsetHeight}px`;
      document.documentElement.style.setProperty('--header-height', height);
    }
  }

  // Initial set
  updateHeaderHeightVar();

  // Update on resize
  window.addEventListener('resize', updateHeaderHeightVar);

  // Update on actual header size changes (like fonts/images loading)
  const ro = new ResizeObserver(updateHeaderHeightVar);
  if (header) ro.observe(header);

  document.querySelector('.searchIcn').addEventListener('click', () => {
    document?.querySelector('.hdicon.navToggle.open')?.classList.toggle('open')
  })

})

// window.addEventListener('variantChanged', (event) => {

//   let variantSoldOut = productVariants.find(variant => variant.id === event.detail.variantId)?.force_sold_out == true;
//   if(variantSoldOut == true){
//     // document.querySelector('body').classList.add("force_sold_out")
//   } else {
//     // document.querySelector('body').classList.remove("force_sold_out")
//   }

// })

// document.addEventListener('DOMContentLoaded', (event) => {
//   let params = new URLSearchParams(document.location.search);
//   let variantLookupId = parseInt(params.get("variant") || productVariants[0].id)
//   let variantSoldOut = productVariants.find(variant => variant.id === variantLookupId)?.force_sold_out == true;
//   if(variantSoldOut == true){
//     // document.querySelector('body').classList.add("force_sold_out")
//   } else {
//     // document.querySelector('body').classList.remove("force_sold_out")
//   }
// })